import type { DatasetData } from "metabase-types/api";

/** Column names removed from query-result data before any card visualization renders. */
const COLUMN_NAMES_HIDDEN_FROM_CARD_DISPLAY = new Set([
  "account_id",
  "col_user_id",
]);

export function stripColumnsHiddenFromDisplay(data: DatasetData): DatasetData {
  const hidden = COLUMN_NAMES_HIDDEN_FROM_CARD_DISPLAY;
  const keepIndexes = data.cols
    .map((col, idx) => (!hidden.has(col.name) ? idx : null))
    .filter((idx): idx is number => idx !== null);

  if (keepIndexes.length === data.cols.length) {
    return data;
  }

  const cols = keepIndexes.map((i) => data.cols[i]);
  const rows = data.rows.map((row) => keepIndexes.map((i) => row[i]));

  const results_metadata =
    data.results_metadata?.columns &&
    data.results_metadata.columns.length === data.cols.length
      ? {
          ...data.results_metadata,
          columns: keepIndexes.map((i) => data.results_metadata.columns[i]),
        }
      : data.results_metadata;

  return {
    ...data,
    cols,
    rows,
    results_metadata,
  };
}
